const values = [
  {
    title: 'Innovation',
    subtitle: 'Continuous exploration',
    description:
      'Actively exploring new technologies and evolving internal processes to maintain high technical excellence.',
  },
  {
    title: 'Stability',
    subtitle: 'Long-term reliability',
    description:
      'Building systems with durability in mind — every component engineered to perform consistently over time.',
  },
  {
    title: 'Usability',
    subtitle: 'Human-centered engineering',
    description:
      'Designing solutions around real user needs, ensuring intuitive experiences that reduce friction and enhance productivity.',
  },
];

export default function CoreValuesSection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-[2rem] md:text-[2.6rem] text-foreground-950 text-center tracking-[-0.01em]">
          Core Values
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-16 md:mt-20">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-[24px] p-10 md:p-12 flex flex-col items-center text-center relative overflow-hidden"
              style={{
                background: 'linear-gradient(160deg, oklch(0.965 0.003 85) 0%, oklch(0.94 0.004 87) 50%, oklch(0.915 0.004 88) 100%)',
              }}
            >
              {/* Subtle decorative grain texture */}
              <div className="absolute inset-0 opacity-[0.03]"
                style={{
                  backgroundImage: 'radial-gradient(oklch(0.4 0.01 85) 1px, transparent 1px)',
                  backgroundSize: '4px 4px',
                }}
              />
              <div className="relative z-10">
                <h3 className="font-heading text-2xl md:text-[1.75rem] text-foreground-950 font-semibold">
                  {v.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-1 font-medium tracking-wide">
                  {v.subtitle}
                </p>
                <p className="text-sm text-foreground-600/80 mt-6 leading-relaxed max-w-[260px]">
                  {v.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}